import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { COMPETITION_URL } from 'app/@common/constants'

export default function SelectMainHotels({...props}) {

    const myProps = {
        urlAjax: COMPETITION_URL.MAIN_HOTELS,
        placeholder: i18n.t('common:filters.selectMainHotel'),
        icon: {icon: 'hotel'}, 
        isMulti: false,
        firstSelect: (Array.isArray(props.value) || !props.value),
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}
